export const OTP_ATTEMPT_LENGTH = 6;
export const RECOVERY_EMAIL_VERIFICATION_CODE_LENGTH = 6;
export const PHONE_VERIFICATION_CODE_LENGTH = 4;
